<div class="header">
  <div class="title">パスワードリセット</div>
</div>
<mat-dialog-content>
  <div class="content">
    @if (showSpinner) {
      <div class="spinner center">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
    <div class="form-area">
      <form [formGroup]="form">
        <div class="flex">
          <div class="label">ID</div>
          <mat-form-field class="input-area no-line">
            <input matInput
              formControlName="mailaddress"
              (input)="onInput()"
              type="text"
              />
          </mat-form-field>
        </div>
        <div class="flex">
          <div class="label">役職</div>
          <div class="readonly-field">{{ account.officialposition_name }}</div>
        </div>
        <div class="flex">
          <div class="label">権限</div>
          <div class="authority-plain-text">
            {{ account.is_master_account ? '管理（固定）' : getAuthLabel(account.user_authority) }}
          </div>
        </div>
    </form>
      <div class="text">
        <div><span class="phrase">リセット実行後に発行される</span><span class="phrase">パスワードを</span></div>
        <div>忘れずにご本人へお伝えください。</div>
       </div>
  </div>
}
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (isSaving) {
    <mat-spinner diameter="28" class="spinner"></mat-spinner>
  }
  <button mat-raised-button mat-dialog-close>キャンセル</button>
  <button mat-raised-button (click)="onSave()" [disabled]="isSaving" class="yes-btn">実行</button>
</mat-dialog-actions>
